import { useTranslation } from 'react-i18next';
import { $userStore } from '@lib/store';
import type { ProfileResponse } from '@shared/api';
import { Button, Modal, Text } from '@shared/widgets';

interface LockUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: ProfileResponse;
}

export const LockUserModal = (props: LockUserModalProps) => {
  const { t } = useTranslation('user');

  const lockUnlockHandler = () => {
    if (props.user.locked) $userStore.events.unlockUser(props.user.id);
    $userStore.events.lockUser(props.user.id);
    props.onClose();
  };

  return (
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      title={t('sidebar.modals.lockUnlock.title', { action: t(`sidebar.modals.lockUnlock.${props.user.locked ? 'unlock' : 'lock'}`) })}
    >
      <Text>
        {t('sidebar.modals.lockUnlock.description', {
          action: t(`sidebar.modals.lockUnlock.${props.user.locked ? 'unlock' : 'lock'}`).toLowerCase(),
        })}
      </Text>
      <div className='mt-6 flex justify-between gap-2'>
        <Button color='outlined' fullWidth onClick={props.onClose}>
          {t('buttons.close', { ns: 'common' })}
        </Button>
        <Button fullWidth color='primary' onClick={lockUnlockHandler}>
          {t(`buttons.${props.user.locked ? 'unlock' : 'lock'}`, { ns: 'common' })}
        </Button>
      </div>
    </Modal>
  );
};
